import React from 'react';

class DropdownSelect extends React.Component {
  render() {
    const { input, options, defaultOption, id, dir, disabled } = this.props;
    return (
      <label className="mk-select-label">
        <select
          {...input}
          className={`mk-select`}
          id={id}
          dir={dir}
          disabled={disabled}
        >
          {defaultOption && (
            <option value={defaultOption.id} selected="selected">
              {defaultOption.name}
            </option>
          )}
          {options.map(option => (
            <option value={option.id} key={option.id}>
              {option.name}
            </option>
          ))}
        </select>
      </label>
    );
  }
}

DropdownSelect.propTypes = {};

DropdownSelect.defaultProps = {
  disabled: false,
};

export default DropdownSelect;
